<template>
	<div class="container">
		<div v-html="detailmodel.schedule">
			
		</div>
	</div>
</template>

<script>
	import competitionModules from '@/modules/competition.js'
	export default {
		name: 'competitionTime',
		components: {
			
		},
		mixins: [
			competitionModules
		],
		data(){
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
	.container{
		img{
			max-width: 100%;
		}
	}
</style>
